import { Record, List, RecordOf } from 'immutable';

export const PAYMENT_PROVIDERS_NAMES = {
  openFinance: 'open_finance',
} as const;

export type PaymentProviderName = (typeof PAYMENT_PROVIDERS_NAMES)[keyof typeof PAYMENT_PROVIDERS_NAMES];

export const PROVIDER_USER_GROUPS = {
  controller: 'payment_controllers',
  approver: 'payment_approvers',
} as const;

export type ProviderUserGroups = (typeof PROVIDER_USER_GROUPS)[keyof typeof PROVIDER_USER_GROUPS];

export const PAYMENT_PROVIDERS_TITLES = {
  [PAYMENT_PROVIDERS_NAMES.openFinance]: 'Open Finance',
};

export const PaymentProviderStatuses = {
  connected: 'connected',
  disconnected: 'disconnected',
} as const;

export type PaymentProviderStatus = (typeof PaymentProviderStatuses)[keyof typeof PaymentProviderStatuses];

// ========== PaymentProvider ==========
export interface PaymentProviderData {
  providerName: PaymentProviderName | '';
  status: PaymentProviderStatus;
  id: string | null;
  displayName: string;
}
export type PaymentProviderRecord = RecordOf<PaymentProviderData>;
export type PaymentProvidersList = List<PaymentProviderRecord>;

const PaymentProviderRecordFactory = Record<PaymentProviderData>({
  providerName: '',
  status: PaymentProviderStatuses.disconnected,
  id: null,
  displayName: '',
});

export const paymentProviderFactory = (data: Partial<PaymentProviderData>): PaymentProviderRecord =>
  PaymentProviderRecordFactory(data);

export const paymentProvidersList = (list: Array<Partial<PaymentProviderData>> = []): PaymentProvidersList =>
  List(list).map((item) => paymentProviderFactory(item));

// ========== ProviderUser ==========
export interface ProviderUserData {
  id: string;
  fullName: string;
  avatar: string | null;
  username: string;
  isOwner: boolean;
  isApprover: boolean;
  isController: boolean;
}
export type ProviderUserRecord = RecordOf<ProviderUserData>;
export type ProviderUsersList = List<ProviderUserRecord>;

const ProviderUserRecordFactory = Record<ProviderUserData>({
  id: '',
  fullName: '',
  avatar: null,
  username: '',
  isOwner: false,
  isApprover: false,
  isController: false,
});

export const providerUserFactory = (user: Partial<ProviderUserData>): ProviderUserRecord =>
  ProviderUserRecordFactory({ id: user.username || '', ...user });

export const providerUsersList = (users: Array<Partial<ProviderUserData>> = []): ProviderUsersList =>
  List(users).map(providerUserFactory);

// ========== PayApprover ==========
export interface PayApproverData {
  id: string | null;
  avatar: string;
  fullName: string;
  username: string;
}
export type PayApproverRecord = RecordOf<PayApproverData>;
export type PayApproversList = List<PayApproverRecord>;

const PayApproverRecordFactory = Record<PayApproverData>({
  id: null,
  avatar: '',
  fullName: '',
  username: '',
});

export const payApproverFactory = (data: Partial<PayApproverData>): PayApproverRecord => PayApproverRecordFactory(data);

export const payApproversList = (list: Array<Partial<PayApproverData>> = []): PayApproversList =>
  List(list).map(payApproverFactory);
